/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0CompanyGetCompaniesGet$Json } from '../fn/company/api-v-0-company-get-companies-get-json';
import { ApiV0CompanyGetCompaniesGet$Json$Params } from '../fn/company/api-v-0-company-get-companies-get-json';
import { apiV0CompanyGetCompaniesGet$Plain } from '../fn/company/api-v-0-company-get-companies-get-plain';
import { ApiV0CompanyGetCompaniesGet$Plain$Params } from '../fn/company/api-v-0-company-get-companies-get-plain';
import { apiV0CompanyGetLastDataUpdatesGet$Json } from '../fn/company/api-v-0-company-get-last-data-updates-get-json';
import { ApiV0CompanyGetLastDataUpdatesGet$Json$Params } from '../fn/company/api-v-0-company-get-last-data-updates-get-json';
import { apiV0CompanyGetLastDataUpdatesGet$Plain } from '../fn/company/api-v-0-company-get-last-data-updates-get-plain';
import { ApiV0CompanyGetLastDataUpdatesGet$Plain$Params } from '../fn/company/api-v-0-company-get-last-data-updates-get-plain';
import { apiV0CompanyPost } from '../fn/company/api-v-0-company-post';
import { ApiV0CompanyPost$Params } from '../fn/company/api-v-0-company-post';
import { Company } from '../models/company';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0CompanyGetCompaniesGet()` */
  static readonly ApiV0CompanyGetCompaniesGetPath = '/api/v0/company/getCompanies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CompanyGetCompaniesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetCompaniesGet$Plain$Response(params?: ApiV0CompanyGetCompaniesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
    const obs = apiV0CompanyGetCompaniesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CompanyGetCompaniesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetCompaniesGet$Plain(params?: ApiV0CompanyGetCompaniesGet$Plain$Params, context?: HttpContext): Observable<Array<Company>> {
    const resp = this.apiV0CompanyGetCompaniesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Company>>): Array<Company> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CompanyGetCompaniesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetCompaniesGet$Json$Response(params?: ApiV0CompanyGetCompaniesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
    const obs = apiV0CompanyGetCompaniesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CompanyGetCompaniesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetCompaniesGet$Json(params?: ApiV0CompanyGetCompaniesGet$Json$Params, context?: HttpContext): Observable<Array<Company>> {
    const resp = this.apiV0CompanyGetCompaniesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Company>>): Array<Company> => r.body)
    );
  }

  /** Path part for operation `apiV0CompanyGetLastDataUpdatesGet()` */
  static readonly ApiV0CompanyGetLastDataUpdatesGetPath = '/api/v0/company/getLastDataUpdates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CompanyGetLastDataUpdatesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetLastDataUpdatesGet$Plain$Response(params?: ApiV0CompanyGetLastDataUpdatesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    const obs = apiV0CompanyGetLastDataUpdatesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CompanyGetLastDataUpdatesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetLastDataUpdatesGet$Plain(params?: ApiV0CompanyGetLastDataUpdatesGet$Plain$Params, context?: HttpContext): Observable<Array<number>> {
    const resp = this.apiV0CompanyGetLastDataUpdatesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CompanyGetLastDataUpdatesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetLastDataUpdatesGet$Json$Response(params?: ApiV0CompanyGetLastDataUpdatesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    const obs = apiV0CompanyGetLastDataUpdatesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CompanyGetLastDataUpdatesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0CompanyGetLastDataUpdatesGet$Json(params?: ApiV0CompanyGetLastDataUpdatesGet$Json$Params, context?: HttpContext): Observable<Array<number>> {
    const resp = this.apiV0CompanyGetLastDataUpdatesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `apiV0CompanyPost()` */
  static readonly ApiV0CompanyPostPath = '/api/v0/company';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0CompanyPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CompanyPost$Response(params?: ApiV0CompanyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0CompanyPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0CompanyPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0CompanyPost(params?: ApiV0CompanyPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0CompanyPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
